import { getMessages } from '../../../../store/constants';

export const OFFLINE_TITLE = getMessages().getText('offline.blocker.title');
export const OFFLINE_TEXT = getMessages().getText('offline.blocker.text');
